import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/app/contexts/AuthContext';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { ScopeMap } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/mapper';
import { useBrandingContext } from '@trufla-technology/trufla-trudomain/dist/lib';
import { ErrorHandler } from '@trufla-technology/trumarket-react-design-system';

type Props = {
  path: string;
  component?: any;
  permission?: Array<keyof typeof ScopeMap>;
  redirect?: string;
};

export const TruRoute = ({
  component: Component,
  permission,
  redirect,
  path,
}: Props) => {
  const { isPermitted } = useAuthContext();
  const history = useHistory();
  const {
    branding: { logoUrl },
  } = useBrandingContext();

  const NotFoundRoute = () => (
    <ErrorHandler
      logoUrl={logoUrl!}
      status="404"
      messageError="not-found"
      onClick={() => history.push('/')}
    />
  );
  const UnauthorizedRoute = () => (
    <ErrorHandler
      logoUrl={logoUrl!}
      status="401"
      messageError="Unauthorized"
      onClick={() => history.push('/')}
    />
  );

  const getPermissions = (perms: Array<keyof typeof ScopeMap>): boolean => {
    let permissionState = true;
    perms.forEach((state: keyof typeof ScopeMap) => {
      permissionState = isPermitted(state) && permissionState;
    });
    return permissionState;
  };

  if (!Component && redirect)
    return (
      <>
        <Route exact path={path}>
          <Redirect to={redirect} />
        </Route>
        <Route component={NotFoundRoute} />
      </>
    );

  if (!permission || getPermissions(permission))
    return (
      <Route exact={path !== '/users/:key'} path={path} component={Component} />
    );

  return <Route component={UnauthorizedRoute} />;
};
